import React from 'react';

export default function NotFOund(props) {
    return(
        <div>
            Not Found 404
        </div>
    )
}